// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CostClassDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class CostClassApiClient extends BaseCRUDApiClient<CostClassDto> {
  baseUrl = this.config.apiEndpoint + '/cost-class';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
